// @mui
import { Box } from '@mui/material';
//
import { FROST, STAGE, TYPE } from '../../theme/stage';
import { ANCHOR, SKIP_LINK } from './copy';
import { focusTarget } from './focus';

// ----------------------------------------------------------------------

export function focusMain() {
  const main = document.getElementById(ANCHOR.main);
  if (!main) {
    return;
  }
  focusTarget(main);
}

export default function SkipLink() {
  return (
    <Box
      component="a"
      href={`#${ANCHOR.main}`}
      onClick={focusMain}
      data-frost
      sx={{
        ...FROST,
        ...TYPE.button,
        position: 'fixed',
        top: 12,
        left: 12,
        zIndex: 50,
        display: 'inline-flex',
        alignItems: 'center',
        height: 44,
        px: '16px',
        borderRadius: '999px',
        color: STAGE.ink,
        whiteSpace: 'nowrap',
        textDecoration: 'none',
        transform: 'translateY(calc(-100% - 24px))',
        '&:focus': { transform: 'none' },
      }}
    >
      {SKIP_LINK}
    </Box>
  );
}
